import LibraryModel from '../../models/manage/LibraryModel.js';

const LibraryCollection = Backbone.Collection.extend({
  name: 'libraries',
  model: LibraryModel,
  initialize() {

    // this.getCurrentUserDetails();

  },

  getCurrentUserDetails() {
    const details = loginContext.getCurrentDetails();
    this.$user_id = details.user_id;
    this.$username = details.username;
  },

  getMyLibraries() {
    const libraries = this.toJSON();
    const that = this;

    this.getCurrentUserDetails();

    const myLibraries = _.filter(libraries, (library) => that.$user_id === library.user_id);

    return myLibraries;
  },
  getLibrariesSharedWithMe() {
    const libraries = this.toJSON();
    const that = this;
    this.getCurrentUserDetails();

    this.getCurrentUserDetails();

    const sharedLibraries = _.filter(libraries, (library) => that.$user_id !== library.user_id);

    return sharedLibraries;
  },
  sync(method, collection, options) {
    this.getCurrentUserDetails();

    // Possible methods: create, read, update, dete
    const defer = $.Deferred();
    // options.reset = ( method === "read" ) ? false : true;
    options.reset = (options.reset === undefined ? true : options.reset);

    if (method == 'read') {
      const that = this;
      const username = this.$username;
      const key = `${username}_libraries`;
      const cache = new Cache();

      if (cache.read(key) == null || options.ignoreCache) {
        return Sendible.Connect.getContentLibraries(
          window.appConfig.applicationId,
          $username,
          $password,
          { type: options.type },
          (data) => {
            that.myLibraries = [];
            that.sharedLibraries = [];

            _.each(data, (library) => {
              library.consumerList = '';
              library.contributorList = '';
              if (library.consumers && library.consumers.length) {
                library.consumerList = _.pluck(_.pluck(library.consumers, 'user'), 'id').join(',');
              }

              if (library.contributors && library.contributors.length) {
                library.contributorList = _.pluck(_.pluck(library.contributors, 'user'), 'id').join(',');
              }
            });

            options.success(data);
            defer.resolve(data);
          },
          (data) => {
            options.error(data);
            defer.reject(data);
          },
        );
      }

      const data = JSON.parse(cache.read(key));
      options.success(data);
      defer.resolve(data);
    }
    const promise = defer.promise();
    return promise;
  },

});

export default LibraryCollection;
